import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
    selector: 'common-heading-plus',
    templateUrl: './heading-plus.component.html',
    styleUrls: ['./heading-plus.component.scss']
})
export class HeadingPlusComponent implements OnInit {

    @Input('section') section: any;

    @Input('disabled') disabled: boolean;

    @Output('addLineCallback') addLineCallback = new EventEmitter<any>();

    constructor() {
    }

    ngOnInit(): void {
    }

    onAddLineClick(): void {
        this.addLineCallback.emit(this.section);
    }
}
